import { put, call, all, takeLatest } from 'redux-saga/effects';
import { notification } from 'antd';
import get from 'lodash/get';
import { fetchAssetCompanySuccess, fetchAssetCompanyFailure } from './action';
import { FETCH_ASSET_COMPANY } from './types';
import adminAxiosConfig from '../../../services/adminAxiosConfig';

/** Get all listed equipments */
function* fetchAssetCompany() {
  try {
    const res = yield adminAxiosConfig.get('/asset-companies');
    const response = get(res, ['data', 'data'], {});
    if (res.status === 200) {
      yield put(fetchAssetCompanySuccess({ response }));
    } else {
      yield put(fetchAssetCompanyFailure());
      notification.error({
        message: 'Something went wrong.',
      });
    }
  } catch (error) {
    yield put(fetchAssetCompanyFailure());
    notification.destroy();
    notification.error({
      message: 'A problem occured while fetching the Asset Company Details.',
      description: `${error.error}`,
    });
  }
}

function* sowWatcher() {
  yield takeLatest(FETCH_ASSET_COMPANY, fetchAssetCompany);
}

function* assetCompanySagas() {
  yield all([call(sowWatcher)]);
}

export default assetCompanySagas;
